/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { GeneralInput } from '../../components/core/input'
import {
  Document,
  Dot,
  Increase,
  Decrase,
  LangArrows,
  SearchIcon,
} from '../../icons'
import { useState, useContext, useEffect } from 'react'
import Subscribe from '../../components/pages/subscribe'
import PagesAPI from '../../api/pages'
import CurrencyAPI from '../../api/currency'
import Loading from '../../components/pages/loading'
import * as XLSX from 'xlsx'

const trCurrencyNames = {
  USD: '1 ABD Doları',
  EUR: '1 Euro',
  RUB: '1 Rus Rublesi',
  TRY: '1 Türk Lirası',
  GBP: '1 İngiliz Sterlini',
  AED: '1 BAE Dirhemi',
  AUD: '1 Avustralya Doları',
  BYN: '1 Belarus Rublesi',
  CAD: '1 Kanada Doları',
  CHF: '1 İsviçre Frangı',
  CNY: '1 Çin Yuanı',
  CZK: '1 Çek Korunası',
  DKK: '1 Danimarka Kronu',
  EGP: '1 Mısır Lirası',
  GEL: '1 Gürcistan Larisi',
  HKD: '1 Hong Kong Doları',
  HUF: '1 Macar Forinti',
  IDR: '100 Endonezya Rupisi',
  ILS: '1 İsrail Şekeli',
  INR: '1 Hindistan Rupisi',
  IRR: '100 İran Riyali',
  ISK: '1 İzlanda Kronu',
  JPY: '100 Japon Yeni',
  KGS: '1 Kırgız Somu',
  KRW: '100 Güney Kore Wonu',
  KWD: '1 Kuveyt Dinarı',
  KZT: '1 Kazakistan Tengesi',
  MDL: '1 Moldova Leyi',
  MYR: '1 Malezya Ringgiti',
  NOK: '1 Norveç Kronu',
  NZD: '1 Yeni Zelanda Doları',
  PLN: '1 Polonya Zlotisi',
  QAR: '1 Katar Riyali',
  SAR: '1 Suudi Arabistan Riyali',
  SEK: '1 İsveç Kronu',
  SGD: '1 Singapur Doları',
  TJS: '1 Tacikistan Somonisi',
  TMT: '1 Türkmenistan Manatı',
  UAH: '1 Ukrayna Grivnası',
  UZS: '100 Özbekistan Somu',
  ZAR: '1 Güney Afrika Randı',
  ARS: '1 Arjantin Pesosu',
  BRL: '1 Brezilya Reali',
  CLP: '100 Şili Pesosu',
  MXN: '1 Meksika Pesosu',
  XPD: 'Paladyum',
  XPT: 'Platin',
  XAG: 'Gümüş',
  XAU: 'Altın',
  AZN: '1 Azerbaycan Manatı',
}


const Sparkline = ({ sign }) => {
  const isUp = sign === 'up';
  const isDown = sign === 'down';
  const strokeColor = isUp ? '#10b981' : isDown ? '#f43f5e' : '#94a3b8';
  const d = isUp 
    ? 'M 2 18 Q 14 15, 26 16 T 46 8 T 62 3' 
    : isDown 
    ? 'M 2 3 Q 14 7, 26 5 T 46 13 T 62 18' 
    : 'M 2 10 Q 16 8, 30 11 T 46 9 T 62 10';
  return (
    <svg width="64" height="20" viewBox="0 0 64 20" style={{ display: 'inline-block', verticalAlign: 'middle', filter: `drop-shadow(0 0 4px ${strokeColor}66)` }}>
      <path d={d} fill="none" stroke={strokeColor} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
};

const Currency = ({ className }) => {
  const { language } = useContext(PageContext)
  const [first, setFirst] = useState(true)
  const [bool1, setBool1] = useState(false)
  const [bool2, setBool2] = useState(false)
  const [choice1, setChoice1] = useState('AZN')
  const [choice2, setChoice2] = useState('USD')
  const [currSearch, setCurrSearch] = useState('')
  const fileName = 'AZN məzənnələrin tam siyahısı'

  const getCurrencyName = (item) => {
    if (!item) return ''
    const code = (item.code || '').toUpperCase()
    if (language === 'TR') {
      return trCurrencyNames[code] || item.currency?.TR || item.currency?.AZ || item.currency?.ENG || code
    }
    return item.currency?.[language] || item.currency?.AZ || item.currency?.ENG || code
  }
  const headers = first
    ? [
        // { label: 'Valyuta', key: 'currency' },
        { label: 'Kod', key: 'code' },
        { label: 'Kurs', key: 'rate' },
        // { label: '', key: 'sign' },
      ]
    : [
        { label: 'Date', key: 'date' },
        { label: 'Source', key: 'src' },
        { label: 'Currency', key: 'cur' },
        { label: 'Rate', key: 'rate' },
      ]
  const [data, setData] = useState(null)

  const exportToExcel = () => {
    if (!data || !data.length) return
    let rows = []
    if (first) {
      rows = data.map((item) => ({
        [language === 'TR' ? 'Döviz' : language === 'ENG' ? 'Currency' : language === 'RU' ? 'Валюта' : 'Valyuta']: getCurrencyName(item),
        [language === 'TR' ? 'Döviz Kodu' : language === 'ENG' ? 'Currency Code' : language === 'RU' ? 'Код Валюты' : 'Valyuta Kodu']: (item.code || '').toUpperCase(),
        [language === 'TR' ? 'Resmi Kur (AZN)' : language === 'ENG' ? 'Official Rate (AZN)' : language === 'RU' ? 'Официальный Курс (AZN)' : 'Rəsmi Məzənnə (AZN)']: Number(item.rate) || item.rate,
        [language === 'TR' ? 'Tarih' : language === 'ENG' ? 'Date' : language === 'RU' ? 'Дата' : 'Tarix']: new Date().toLocaleDateString(language === 'TR' ? 'tr-TR' : 'az-AZ'),
      }))
    } else {
      rows = data.map((item) => ({
        [language === 'TR' ? 'Tarih' : language === 'ENG' ? 'Date' : language === 'RU' ? 'Дата' : 'Tarix']: item.date,
        [language === 'TR' ? 'Kaynak Döviz' : language === 'ENG' ? 'Source Currency' : language === 'RU' ? 'Исходная Валюта' : 'Mənbə Valyuta']: source,
        [language === 'TR' ? 'Hedef Döviz' : language === 'ENG' ? 'Target Currency' : language === 'RU' ? 'Целевая Валюта' : 'Hədəf Valyuta']: cur,
        [language === 'TR' ? 'Kur' : language === 'ENG' ? 'Rate' : language === 'RU' ? 'Курс' : 'Məzənnə']: Number(item.rate) || item.rate,
      }))
    }

    const ws = XLSX.utils.json_to_sheet(rows)
    const colWidths = Object.keys(rows[0] || {}).map((key) => {
      const maxLen = Math.max(
        key.length,
        ...rows.map((r) => String(r[key] || '').length)
      )
      return { wch: Math.max(maxLen + 4, 16) }
    })
    ws['!cols'] = colWidths

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Məzənnələr')
    const todayStr = new Date().toISOString().split('T')[0]
    XLSX.writeFile(wb, `BPG_Mezenne_${todayStr}.xlsx`)
  }
  const list = [
    {
      valyuta: '1 Azərbaycan manatı',
      kod: 'AZN',
    },
    {
      valyuta: '1 ABŞ dolları',
      kod: 'USD',
    },
    {
      valyuta: '1 Avro',
      kod: 'EUR',
    },
    {
      valyuta: '1 Avstraliya dolları',
      kod: 'AUD',
    },
    {
      valyuta: '1 Argentina pesosu',
      kod: 'ARS',
    },
    {
      valyuta: '1 Belarus rublu',
      kod: 'BYN',
    },
    {
      valyuta: '1 Braziliya realı',
      kod: 'BRL',
    },
    {
      valyuta: '1 BƏƏ dirhəmi',
      kod: 'AED',
    },
    {
      valyuta: '1 Cənubi Afrika randı',
      kod: 'ZAR',
    },
    {
      valyuta: '100 Cənubi Koreya vonu',
      kod: 'KRW',
    },
    {
      valyuta: '1 Çexiya kronu',
      kod: 'CZK',
    },
    {
      valyuta: '100 Çili pesosu',
      kod: 'CLP',
    },
    {
      valyuta: '1 Çin yuanı',
      kod: 'CNY',
    },
    {
      valyuta: '1 Danimarka kronu',
      kod: 'DKK',
    },
    {
      valyuta: '1 Gürcüstan larisi',
      kod: 'GEL',
    },
    {
      valyuta: '1 Honq Konq dolları',
      kod: 'HKD',
    },
    {
      valyuta: '1 Hindistan rupisi',
      kod: 'INR',
    },
    {
      valyuta: '1 İngiltərə funt sterlinqi',
      kod: 'GBP',
    },
    {
      valyuta: '100 İndoneziya rupiası',
      kod: 'IDR',
    },
    {
      valyuta: '100 İran rialı',
      kod: 'IRR',
    },
    {
      valyuta: '1 İsveç kronu',
      kod: 'SEK',
    },
    {
      valyuta: '1 İsveçrə frankı',
      kod: 'CHF',
    },
    {
      valyuta: '1 İsrail şekeli',
      kod: 'ILS',
    },
    {
      valyuta: '1 Kanada dolları',
      kod: 'CAD',
    },
    {
      valyuta: '1 Küveyt dinarı',
      kod: 'KWD',
    },
    {
      valyuta: '1 Qazaxıstan tengəsi',
      kod: 'KZT',
    },
    {
      valyuta: '1 Qırğızıstan somu',
      kod: 'KGS',
    },
    {
      valyuta: '100 Livan funtu',
      kod: 'LBP',
    },
    {
      valyuta: '1 Malayziya rinqqiti',
      kod: 'MYR',
    },
    {
      valyuta: '1 Meksika pesosu',
      kod: 'MXN',
    },
    {
      valyuta: '1 Moldova leyi',
      kod: 'MDL',
    },
    {
      valyuta: '1 Misir funtu',
      kod: 'EGP',
    },
    {
      valyuta: '1 Norveç kronu',
      kod: 'NOK',
    },
    {
      valyuta: '100 Özbəkistan somu',
      kod: 'UZS',
    },
    {
      valyuta: '1 Polşa zlotısı',
      kod: 'PLN',
    },
    {
      valyuta: '1 Rusiya rublu',
      kod: 'RUB',
    },
    {
      valyuta: '1 Sinqapur dolları',
      kod: 'SGD',
    },
    {
      valyuta: '1 Səudiyyə Ərəbistanı rialı',
      kod: 'SAR',
    },
    {
      valyuta: '1 SDR (BVF-nin xüsusi borcalma hüquqları)',
      kod: 'XDR',
    },
    {
      valyuta: '1 Türkiyə lirəsi',
      kod: 'TRY',
    },
    {
      valyuta: '1 Tayvan dolları',
      kod: 'TWD',
    },
    {
      valyuta: '1 Tacikistan somonisi',
      kod: 'TJS',
    },
    {
      valyuta: '1 Türkmənistan manatı',
      kod: 'TMT',
    },
    {
      valyuta: '1 Ukrayna qrivnası',
      kod: 'UAH',
    },
    {
      valyuta: '100 Yaponiya yeni',
      kod: 'JPY',
    },
    {
      valyuta: '1 Yeni Zelandiya dolları',
      kod: 'NZD',
    },
  ]
  const list2 = [
    {
      valyuta: 'Azərbaycan manatı',
      kod: 'AZN',
    },
    {
      valyuta: 'ABŞ dolları',
      kod: 'USD',
    },
    {
      valyuta: 'Avro',
      kod: 'EUR',
    },
    {
      valyuta: 'Avstraliya dolları',
      kod: 'AUD',
    },
    {
      valyuta: 'Argentina pesosu',
      kod: 'ARS',
    },
    {
      valyuta: 'Belarus rublu',
      kod: 'BYN',
    },
    {
      valyuta: 'Braziliya realı',
      kod: 'BRL',
    },
    {
      valyuta: 'BƏƏ dirhəmi',
      kod: 'AED',
    },
    {
      valyuta: 'Cənubi Afrika randı',
      kod: 'ZAR',
    },
    {
      valyuta: 'Cənubi Koreya vonu',
      kod: 'KRW',
    },
    {
      valyuta: 'Çexiya kronu',
      kod: 'CZK',
    },
    {
      valyuta: 'Çili pesosu',
      kod: 'CLP',
    },
    {
      valyuta: 'Çin yuanı',
      kod: 'CNY',
    },
    {
      valyuta: 'Danimarka kronu',
      kod: 'DKK',
    },
    {
      valyuta: 'Gürcüstan larisi',
      kod: 'GEL',
    },
    {
      valyuta: 'Honq Konq dolları',
      kod: 'HKD',
    },
    {
      valyuta: 'Hindistan rupisi',
      kod: 'INR',
    },
    {
      valyuta: 'İngiltərə funt sterlinqi',
      kod: 'GBP',
    },
    {
      valyuta: 'İndoneziya rupiası',
      kod: 'IDR',
    },
    {
      valyuta: 'İran rialı',
      kod: 'IRR',
    },
    {
      valyuta: 'İsveç kronu',
      kod: 'SEK',
    },
    {
      valyuta: 'İsveçrə frankı',
      kod: 'CHF',
    },
    {
      valyuta: 'İsrail şekeli',
      kod: 'ILS',
    },
    {
      valyuta: 'Kanada dolları',
      kod: 'CAD',
    },
    {
      valyuta: 'Küveyt dinarı',
      kod: 'KWD',
    },
    {
      valyuta: 'Qazaxıstan tengəsi',
      kod: 'KZT',
    },
    {
      valyuta: 'Qırğızıstan somu',
      kod: 'KGS',
    },
    {
      valyuta: 'Livan funtu',
      kod: 'LBP',
    },
    {
      valyuta: 'Malayziya rinqqiti',
      kod: 'MYR',
    },
    {
      valyuta: 'Meksika pesosu',
      kod: 'MXN',
    },
    {
      valyuta: 'Moldova leyi',
      kod: 'MDL',
    },
    {
      valyuta: 'Misir funtu',
      kod: 'EGP',
    },
    {
      valyuta: 'Norveç kronu',
      kod: 'NOK',
    },
    {
      valyuta: 'Özbəkistan somu',
      kod: 'UZS',
    },
    {
      valyuta: 'Polşa zlotısı',
      kod: 'PLN',
    },
    {
      valyuta: 'Rusiya rublu',
      kod: 'RUB',
    },
    {
      valyuta: 'Sinqapur dolları',
      kod: 'SGD',
    },
    {
      valyuta: 'Səudiyyə Ərəbistanı rialı',
      kod: 'SAR',
    },
    {
      valyuta: 'SDR (BVF-nin xüsusi borcalma hüquqları)',
      kod: 'XDR',
    },
    {
      valyuta: 'Türkiyə lirəsi',
      kod: 'TRY',
    },
    {
      valyuta: 'Tayvan dolları',
      kod: 'TWD',
    },
    {
      valyuta: 'Tacikistan somonisi',
      kod: 'TJS',
    },
    {
      valyuta: 'Türkmənistan manatı',
      kod: 'TMT',
    },
    {
      valyuta: 'Ukrayna qrivnası',
      kod: 'UAH',
    },
    {
      valyuta: 'Yaponiya yeni',
      kod: 'JPY',
    },
    {
      valyuta: 'Yeni Zelandiya dolları',
      kod: 'NZD',
    },
  ]
  const [source, setSource] = useState('AZ')
  const [cur, setCur] = useState('USD')
  const [load, setLoad] = useState(false)
  const [load2, setLoad2] = useState(false)
  const [info, setInfo] = useState([])
  const changeTable = async () => {
    await setFirst(false)
    await setLoad2(false)
    const year = new Date().getFullYear()
    let month = new Date().getMonth() + 1
    month = month < 10 ? '0' + month : month
    let day = new Date().getDate()
    day = day < 10 ? '0' + day : day
    const full1 = `${year - 1}-${month}-${day}`
    const full2 = `${year}-${month}-${day}`

    let st = await document.getElementById('currency-start')?.value
    let en = await document.getElementById('currency-end')?.value
    let src = await choice1

    let cur = await choice2

    if (!st) {
      st = full1
    }
    if (!en) {
      en = full2
    }
    await setSource(src)
    await setCur(cur)
    var myHeaders = new Headers()
    myHeaders.append('apikey', 'S9CttK3dUd2NN99eX0uwE9q6nZTdh4Wr')

    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders,
    }
    let response = await fetch(
      `https://api.apilayer.com/currency_data/timeframe?start_date=${st}&end_date=${en}&source=${src}&currencies=${cur}&format=1`,
      requestOptions,
    )
    response = await response.json()
    response = await response.quotes
    let result = []
    let keys = await Object.keys(response)
    await keys.forEach(function (key) {
      result.push({
        date: key,
        rate: response[key][src + cur],
        src: src,
        cur: cur,
      })
    })
    await setData(result)
    await setLoad2(true)
  }
  const getList = async (date) => {
    await setLoad2(false)
    await setFirst(true)
    const x = await date.split('-')
    const value = await `${x[2]}/${x[1]}/${x[0]}`
    const { data } = await CurrencyAPI.getWithDate(value)
    await setData(data)
    await setLoad2(true)
  }
  useEffect(() => {
    (async () => {

    const data1 = await PagesAPI.getMagazinePageInfo()

    await setInfo(data1.data)
    await setLoad(true)
    const { data } = await CurrencyAPI.getAllCurrencies()
    await setData(data)
    await setLoad2(true)
    const date = new Date()
    let day = date.getDate()
    let month = date.getMonth() + 1
    const year = date.getFullYear()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    const today = year + '-' + month + '-' + day
    document.getElementById('datePicker').value = await today
  
    })();
  }, [])
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <Useful search={false} />
      <div className={styles.filter}>
        <GeneralInput
          id="currency-start"
          label={translate.start[language]}
          type={'date'}
        />
        <GeneralInput
          id="currency-end"
          label={translate.end[language]}
          type={'date'}
        />
        <div
          className={styles.select}
          onBlur={() =>
            setTimeout(function () {
              setBool1(false)
            }, 250)
          }
        >
          <p>{translate.source[language]}</p>
          <span tabIndex="1" onClick={() => setBool1(true)}>
            {choice1} <LangArrows />
          </span>
          <ul style={bool1 ? { display: 'block' } : { display: 'none' }}>
            {list.map(
              (e) =>
                choice2 !== e.kod && (
                  <li
                    key={e.kod}
                    onClick={() => {
                      setChoice1(e.kod)
                    }}
                  >
                    {language === 'TR' ? (trCurrencyNames[e.kod] || e.valyuta) : e.valyuta}
                  </li>
                ),
            )}
          </ul>
        </div>
        <div
          className={styles.select}
          onBlur={() =>
            setTimeout(function () {
              setBool2(false)
            }, 250)
          }
        >
          <p>{translate.to[language]}</p>
          <span tabIndex="1" onClick={() => setBool2(true)}>
            {choice2} <LangArrows />
          </span>
          <ul style={bool2 ? { display: 'block' } : { display: 'none' }}>
            {list2.map(
              (e) =>
                choice1 !== e.kod && (
                  <li
                    key={e.kod}
                    onClick={() => {
                      setChoice2(e.kod)
                    }}
                  >
                    {language === 'TR' ? (trCurrencyNames[e.kod] ? trCurrencyNames[e.kod].replace(/^\d+\s*/, '') : e.valyuta) : e.valyuta}
                  </li>
                ),
            )}
          </ul>
        </div>
        <button onClick={() => changeTable()}>
          <SearchIcon />
        </button>
      </div>
      <div className={styles.list}>
        {load2 && (
          <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={exportToExcel}>
            <span style={{ cursor: 'pointer', fontWeight: 'bold', marginRight: '8px' }}>
              {language === 'AZ' ? 'Excel ilə yüklə (.xlsx)' : language === 'RU' ? 'Скачать Excel (.xlsx)' : language === 'TR' ? 'Excel İndir (.xlsx)' : 'Download Excel (.xlsx)'}
            </span>
            <Document />
          </div>
        )}
        {/* <GeneralInput
          onChange={(e) => {
            getList(e.target.value)
          }}
          id="datePicker"
          type={'date'}
        /> */}
      </div>
      
      {/* Live Currency Search Input */}
      <div className={styles.currencySearchBar}>
        <div className={styles.searchInner}>
          <SearchIcon />
          <input
            type="text"
            value={currSearch}
            onChange={(e) => setCurrSearch(e.target.value)}
            placeholder={language === 'AZ' ? 'Valyuta axtarışı (məs: USD, EUR, Rubl, Lirə)...' : language === 'RU' ? 'Поиск валюты (напр: USD, EUR, Рубль)...' : language === 'TR' ? 'Döviz ara (örn: USD, EUR, TL)...' : 'Search currency (e.g. USD, EUR, GBP)...'}
          />
          {currSearch && (
            <button type="button" onClick={() => setCurrSearch('')}>✕</button>
          )}
        </div>
      </div>
  
      {load2 ? (
        <>
          {first ? (
            <table>
              <thead>
                <tr>
                  <th>{translate.currency[language]}</th>
                  <th>{translate.code[language]}</th>
                  <th>{translate.rate[language]}</th>
                  <th>{language === 'AZ' ? 'Trend (7 gün)' : 'Trend'}</th>
                  <th>{''}</th>
                </tr>
              </thead>
              <tbody>
                {(data || [])
                  .filter((c) => {
                    if (!currSearch) return true;
                    const q = currSearch.toLowerCase();
                    const name = getCurrencyName(c).toLowerCase();
                    const code = (c.code || '').toLowerCase();
                    return name.includes(q) || code.includes(q);
                  })
                  .map((item, index) => (
                    <tr key={index}>
                      <td style={{ fontWeight: 600 }}>{getCurrencyName(item)}</td>
                      <td style={{ textTransform: 'uppercase', fontWeight: 700, color: 'var(--bpg-blue, #416db4)' }}>{item.code}</td>
                      <td style={{ fontWeight: 700 }}>{item.rate}</td>
                      <td>
                        <Sparkline sign={item.sign} />
                      </td>
                      <td>
                        {item.sign === 'dot' ? (
                          <Dot />
                        ) : item.sign === 'up' ? (
                          <Increase />
                        ) : (
                          <Decrase />
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>{translate.tarix[language]}</th>
                  <th>{translate.source[language]}</th>
                  <th>{translate.currencies[language]}</th>
                  <th>{translate.rate[language]}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date}</td>
                    <td>{source}</td>
                    <td>{cur}</td>
                    <td>{item.rate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      ) : (
        <Loading />
      )}
    </section>
  ) : (
    <Loading />
  )
}

export default Currency
